import { BooleanInput, Create, NumberInput, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';

const MediaCategoryCreate = () => {
	return (
		<Create resource="vod/category">
			<SimpleForm>
				<TextInput source="hebrew_name" />
				<TextInput source="english_name" />
				<BooleanInput source="visible" />
				<NumberInput source="priority" label="עדיפות" />
				<BooleanInput source="is_global" label="קטגוריה גלובלית" />
				<SelectInput
					source="type"
					label="סוג"
					defaultValue={'video'}
					choices={[
						{ id: 'video', name: 'VOD (וידאו)' },
						{ id: 'podcast', name: 'פודקאסט' },
					]}
				/>
				<ReferenceInput source="parent_category" reference="vod/categories/all" resource="vod/category">
					<SelectInput optionText={'hebrew_name'} />
				</ReferenceInput>
			</SimpleForm>
		</Create>
	);
};

export default MediaCategoryCreate;
